import { render, staticRenderFns } from "./CustomDatepicker.vue?vue&type=template&id=b52fe446&"
import script from "./CustomDatepicker.vue?vue&type=script&lang=js&"
export * from "./CustomDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./CustomDatepicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports